<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">{{pageTitle}}</div>
                <button type="submit" class="back_button btn btn-primary pull-right" v-on:click.prevent="buttonBack">Back</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <form id="benefitForm">
                    <div class="forms-container">
                        <div class="row no-margin">
                            <!--Title-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="title">Title :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="title" type="text" class="form-control" id="title" placeholder="Title" maxlength="90">
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{titleError}}</font>
                                </div>
                            </div>
                            <!--Description-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="description">Description :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="description" type="text" class="form-control" id="description" placeholder="Description" maxlength="250">
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{descriptionError}}</font>
                                </div>
                            </div>
                            <!--Location-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="locationId">State :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="locationId"
                                              multiple
                                              @change="changedValueLoc"
                                              @input="changedValueLocation()"
                                              name="locationId"
                                              id="locationId"
                                              label="text"
                                              :filterable="false"
                                              :options="locationArr"
                                              @search="onSearchLocation"
                                              placeholder="Select State">
                                        <template slot="no-options">
                                            Search State...
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                    </v-select>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{locationError}}</font>
                                </div>
                            </div>
                            <!--Scheduled For-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="roleData">Scheduled For :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="roleId"
                                              @change="changedValue"
                                              @input="changedValueSearchFor()"
                                              name="roleId"
                                              id="roleData"
                                              label="text"
                                              :filterable="false"
                                              :options="roleArr"
                                              @search="onSearchRole"
                                              placeholder="Select Designation">
                                    </v-select>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{scheduledForError}}</font>
                                </div>
                            </div>
                            <!--Status-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="status">Status :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="status"
                                              name="status"
                                              @input="changedValueStatus()"
                                              id="status"
                                              label="text"
                                              :searchable="false"
                                              :filterable="false"
                                              :options="statusArr"
                                              placeholder="Select Status">
                                    </v-select>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{statusError}}</font>
                                </div>
                            </div>
                            <!--Type-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="type">Event Type :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="type"
                                              name="type"
                                              @input="changedValueType()"
                                              id="type"
                                              label="text"
                                              :filterable="false"
                                              :searchable="false"
                                              :options="typeArr"
                                              placeholder="Select Event Type">
                                    </v-select>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{typeError}}</font>
                                </div>
                            </div>
                            <div class="RecursiveType col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="recursiveType">Recurring Type :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="recursiveType"
                                              name="recursiveType"
                                              @input="changedValueRecType()"
                                              id="recursiveType"
                                              label="text"
                                              :filterable="false"
                                              :searchable="false"
                                              :options="recursiveTypeArr"
                                              placeholder="Select Recurring Type">
                                    </v-select>
                                    <font class="text-danger">{{rectypeError}}</font>
                                </div>
                            </div>
                            <div class="WeekDay col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="weekDays">Day Of Week :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="weekDays"
                                              name="weekDays"
                                              @input="changedValueWeekDays()"
                                              id="weekDays"
                                              label="text"
                                              :filterable="false"
                                              :searchable="false"
                                              :options="weekDaysArr"
                                              placeholder="Select Day Of Week">
                                    </v-select>
                                    <font class="text-danger">{{weekDaysError}}</font>
                                </div>
                            </div>
                            <div class="StartDate col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="startDate" slot="before">Start DateTime :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <datePicker id="StartDate" v-model="startDate" :config="optionsStart" @dp-change="changeStartDt()"></datePicker>
                                    <font class="text-danger">{{startDateError}}</font>
                                </div>
                            </div>
                            <!--End Date-->
                            <div class="EndDate col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="endDate" slot="before">End DateTime :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <datePicker id="EndDate" v-model="endDate" :config="optionsEnd" @dp-change="changeEndDt()"></datePicker>
                                </div>
                            </div>
                            <!--Duration-->
                            <!--<div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="duration">Duration :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="duration" type="text" class="form-control" id="duration" placeholder="Duration">
                                    <font class="text-danger">{{durationError}}</font>
                                </div>
                            </div>-->
                            <!--Contact Person-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="userId">Contact Person :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="userId" type="text" class="form-control" id="duration" placeholder="Contact Person">
                                    <!--<v-select v-model="userId"
                                              @change="changedValue"
                                              @input="changedValueContactPerson()"
                                              name="userId"
                                              id="userId"
                                              label="text"
                                              :filterable="false"
                                              :options="userArr"
                                              @search="onSearchUser"
                                              placeholder="Select Contact Person">
                                        <template slot="no-options">
                                            Search Contact Person...
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                    </v-select>-->
                                    <font class="text-danger">{{contactPersonError}}</font>
                                </div>
                            </div>
                            <!--Contact Email-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="contactEmail">Contact Email :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="contactEmail" type="text" class="form-control" id="contactEmail" placeholder="Contact Email">
                                    <font class="text-danger">{{contactEmailError}}</font>
                                </div>
                            </div>
                            <!--Conatct Number-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="contactNumber">Contact Number :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="contactNumber" type="text" class="form-control" id="contactNumber" placeholder="Contact Number">
                                    <font class="text-danger">{{contactNumberError}}</font>
                                </div>
                            </div>
                            <!--Wellness-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="wellnessId">Wellness :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="wellnessId"
                                              @change="changedValue"
                                              @input="changedValueWellness()"
                                              name="wellnessId"
                                              id="wellnessId"
                                              label="text"
                                              :filterable="false"
                                              :options="wellnessArr"
                                              @search="onSearchWellness"
                                              placeholder="Select Wellness">
                                        <template slot="no-options">
                                            Search Wellness...
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                    </v-select>
                                    <font class="text-danger">{{wellnessError}}</font>
                                </div>
                            </div>
                            <!--Error Alert-->
                            <div class="col-12">
                                <div class="col-12 paddingleft0">
                                    <div class="alert alert-danger" id="alertError">
                                        <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                        <strong id="errorMsg" class="error"></strong>
                                    </div>
                                </div>
                            </div>
                            <!--Buttons-->
                            <div class="col-12">
                                <div class="col-12 paddingleft0">
                                    <input id="addBenifitBtn" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="addEvent()">
                                    <input id="addAndContinueBenifitBtn" type="submit" value="Save and Continue" class="btn btn-primary" v-on:click.prevent="addEvent(flag='Save and Continue')">
                                    <input id="CancelBenifit" type="submit" value="Cancel" class="back_button btn btn-primary" v-on:click.prevent="buttonBack">
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- /#page-content-wrapper -->
</template>

<script>
    var self;
    import vSelect from 'vue-select';
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/Footer';
    import SessioMixin from '../../../mixins/sessionmixin';
    import { HTTP } from '../../../http-common';
    import moment from 'moment';

    import datePicker from 'vue-bootstrap-datetimepicker';
    import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

    export default {
        name: 'AddEvent',
        pageTitle: 'Add Event',
        mixins: [SessioMixin],
        components: {
            'v-select': vSelect,
            'datePicker': datePicker,
            'app-backend-footer': BackendFooter,
        },
        data() {
            return {
                /*startDate: new Date(),*/
                startDate: '',
                optionsStart: {
                    format: 'MM/DD/YYYY hh:mmA',
                    //collapse: true,
                    //inline: true,
                    //dayViewHeaderFormat: 'MMM DD YYYY hh:mm',
                    //minDate: new Date(),
                    //minDate: new Date(new Date().setDate(new Date().getDate() - 1)),
                    maxDate: new Date(new Date().setMonth(new Date().getMonth() + 1000)),
                },
                /*endDate: new Date(new Date().setMonth(new Date().getMonth() + 12)),*/
                endDate: '',
                optionsEnd: {
                    format: 'MM/DD/YYYY hh:mmA',
                    //collapse: true,
                    //inline: true,
                    //dayViewHeaderFormat: 'MMM DD YYYY hh:mm',
                    minDate: new Date(),
                },
                //V-model
                title: '',
                description: '',
                duration: '',
                locationId: '',
                locationArr: [],
                userId: '',
                userArr: [],
                locationError: '',
                contactPerson: '',
                contactEmail: '',
                contactNumber: '',
                roleId: '',
                roleArr: [],
                status: {value: 'active', text: 'Active'},
                statusArr: [
                    {value: 'active', text: 'Active'},
                    {value: 'inactive', text: 'Inactive'}
                ],
                type: {value: 'normal', text: 'Normal'},
                typeArr: [
                    {value: 'normal', text: 'Normal'},
                    {value: 'recursive', text: 'Recurring'}
                ],
                recursiveType: {value: 'monthly', text: 'Monthly'},
                recursiveTypeArr: [
                    {value: 'weekly', text: 'Weekly'},
                    {value: 'monthly', text: 'Monthly'},
                    {value: 'yearly', text: 'Annual'}
                ],
                weekDays: {value: '1', text: 'Monday'},
                weekDaysArr: [
                    {value: '1', text: 'Monday'},
                    {value: '2', text: 'Tuesday'},
                    {value: '3', text: 'Wednesday'},
                    {value: '4', text: 'Thursday'},
                    {value: '5', text: 'Friday'},
                    {value: '6', text: 'Saturday'},
                    {value: '7', text: 'Sunday'},
                ],
                wellnessId: '',
                wellnessArr: [],
                //Errors
                titleError: '',
                descriptionError: '',
                startDateError: '',
                endDateError: '',
                durationError: '',
                contactPersonError: '',
                contactEmailError: '',
                contactNumberError: '',
                scheduledForError: '',
                statusError: '',
                typeError: '',
                rectypeError: '',
                weekDaysError: '',
                wellnessError: '',
            }
        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
            self.pageTitle = 'Add Event';
        },
        mounted: function () {
            self.showLoader();
            self.loadLocationsAdd();
            self.loadWellnessAdd();
            self.loadRole();
            /*self.loadUsers();*/
            var path = window.location.pathname;
            var segments = path.split("/");

            if (segments[2] == 'updateevent') {
                if (segments[3]) {
                    self.pageTitle = 'Edit Event';
                    self.loadEvent();
                    $("#addAndContinueBenifitBtn").hide();
                    $("#addBenifitBtn").val("Update");
                    $("#benefitHeader").text("Edit Benefit Video");
                }
            } else {
                self.hideLoader();
            }

            $("#locationId").on('keyup', function () {
                self.locationError = '';
            });
            $("#title").on('keyup', function () {
                self.titleError = '';
            });
            $("#description").on('keyup', function () {
                self.descriptionError = '';
            });
            $("#startDate").on('keyup', function () {
                self.startDateError = '';
            });
            $("#endDate").on('keyup', function () {
                self.endDateError = '';
            });
            /*$("#duration").on('keyup', function () {
             self.durationError = '';
             });*/
            $("#userId").on('keyup', function () {
                self.contactPersonError = '';
            });
            $("#contactEmail").on('keyup', function () {
                self.contactEmailError = '';
            });
            $("#contactNumber").on('keyup', function () {
                self.contactNumberError = '';
            });
            $("#roleData").change(function () {
                self.scheduledForError = '';
            });
            $("#status").change(function () {
                self.statusError = '';
            });
            $("#type").change(function () {
                self.typeError = '';
            });
            $("#recursiveType").change(function () {
                self.rectypeError = '';
            });
            $("#weekDays").change(function () {
                self.weekDaysError = '';
            });

            $("#alertError,.RecursiveType,.WeekDay").hide();
            $('.EndDate,.StartDate').show();
        },
        watch: {
            /*locationId: function (locationId) {
             self.loadWellnessAdd();
             },
             roleId: function (roleId) {
             self.loadWellnessAdd();
             },*/
            type: function (type) {
                var typ = (type === null || typeof type.value === "undefined" || type.value === null || type.value == '') ? '' : type.value;
                /*console.log("typ : " + typ);*/
                if (typ == 'recursive') {
                    $('.RecursiveType').show();
                    /*$('.EndDate').hide();*/
                } else {
                    self.recursiveType = {value: 'monthly', text: 'Monthly'};
                    self.weekDays = {value: '1', text: 'Monday'};
                    $('.RecursiveType').hide();
                    /*$('.EndDate').show();*/
                    $('.StartDate').show();
                    $('.WeekDay').hide();
                }
            },
            recursiveType: function (recursiveType) {
                var typ = (recursiveType === null || typeof recursiveType.value === "undefined" || recursiveType.value === null || recursiveType.value == '') ? '' : recursiveType.value;
                if (typ == 'monthly' || typ == 'yearly') {
                    $('.StartDate').show();
                    $('.WeekDay').hide();
                    $('.EndDate').show();
                } else {
                    $('.WeekDay').show();
                    $('.StartDate').hide();
                    $('.EndDate').hide();
                }
            },
        },
        methods: {
            buttonBack() {
                $(".back_button").prop("disabled", false);
                self.$router.push('/backend/listevent');
            },

            changeStartDt: function () {
                self.startDateError = "";
                self.optionsEnd.minDate = moment(self.changeDateFormat(self.startDate)).subtract(1, 'days').format("MM/DD/YYYY hh:mmA");
            },
            changeEndDt: function () {
                self.endDateError = "";
                self.optionsStart.maxDate = moment(self.changeDateFormat(self.endDate)).add(1, 'days').format("MM/DD/YYYY hh:mmA");
            },
            changedValue: function (value) {
                //console.log(value);
            },
            onSearchRole(search, loading) {
                if (search.length >= 1) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    this.loadRole(loading, search, this);
                }
            },
            onSearchUser(search, loading) {
                if (search.length > 2) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    this.loadUsers(loading, search, this);
                }
            },
            changedValueSearchFor: function () {
                self.scheduledForError = "";
            },
            changedValueStatus: function () {
                self.statusError = "";
            },
            changedValueType: function () {
                self.typeError = "";
            },
            changedValueRecType: function () {
                self.rectypeError = "";
            },
            changedValueWeekDays: function () {
                self.weekDaysError = "";
            },
            onSearchLocation(search, loading) {
                if (search.length > 2) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    this.loadLocationsAdd(loading, search, this);
                }
            },
            changedValueLocation: function () {
                self.locationError = "";

            },
            changedValueLoc: function (value) {
                console.log(value);
                /*console.log(JSON.stringify(self.locationId));
                 console.log(JSON.stringify(self.uniqueArr(self.locationId)));*/
            },
            uniqueArr: function (array) {
                var obj = {};
                for (var i = 0, len = array.length; i < len; i++)
                    obj[array[i]['value']] = array[i];

                array = new Array();
                for (var key in obj)
                    array.push(obj[key]);
                return array;
            },
            changedValueContactPerson: function () {
                self.contactPersonError = "";
            },
            changeStartDate: function () {
                self.startDateError = "";
            },
            onSearchWellness(search, loading) {
                if (search.length > 2) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    this.loadWellnessAdd(loading, search, this);
                }
            },
            changeEndDate: function () {
                self.endDateError = "";
            },
            changedValueWellness: function () {
                self.wellnessError = "";
            },

            checkForm: function () {
                var checked = true;
                var status = document.getElementById("status");
                var type = document.getElementById("type");

                var typ = (self.type === null || typeof self.type.value === "undefined" || self.type.value === null || self.type.value == '') ? '' : self.type.value;
                var recuTyp = (self.recursiveType === null || typeof self.recursiveType.value === "undefined" || self.recursiveType.value === null || self.recursiveType.value == '') ? '' : self.recursiveType.value;
                /*console.log(typ);
                 console.log(recuTyp);*/
                self.locationError = "";
                self.contactPersonError = "";
                if (self.locationId.length === 0) {
                    self.locationError = "State Required";
                    if (checked) {
                        checked = false;
                    }
                }
                self.titleError = "";
                if (!self.title) {
                    self.titleError = "Title Required";
                    if (checked) {
                        checked = false;
                    }
                }
                self.descriptionError = "";
                if (!self.description) {
                    self.descriptionError = "Description Required";
                    if (checked) {
                        checked = false;
                    }
                }
                self.startDateError = "";
                if (typ == 'normal' || recuTyp == 'monthly' || recuTyp == 'yearly') {
                    if (!self.startDate) {
                        self.startDateError = "Start Date Required";
                        if (checked) {
                            checked = false;
                        }
                    }
                }
                /*if (!self.endDate) {
                 self.endDateError = "End Date Required";
                 if (checked) {
                 checked = false;
                 }
                 }*/
                /*self.durationError = "";
                 if (!self.duration) {
                 self.durationError = "Duration Required";
                 if (checked) {
                 checked = false;
                 }
                 } else if (self.duration && !String(self.duration).match(/^[0-9]*$/)) {
                 self.durationError = "Duration Must Be Numeric";
                 if (checked) {
                 checked = false;
                 }
                 }*/
                if (!self.userId && self.contactEmail && !self.validEmail(self.contactEmail)) {
                    self.contactPersonError = 'Please Enter Contact Person First';
                    self.contactEmailError = 'Please Enter Valid Contact Email';
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.userId && self.contactNumber && !String(self.contactNumber).match(/^[0-9]*$/)) {
                    self.contactPersonError = 'Please Enter Contact Person First';
                    self.contactNumberError = "Phone Number Must Be Numeric";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.contactNumber && String(self.contactNumber).match(/^[0-9]*$/) && self.contactNumber.length < 10) {
                    self.contactNumberError = "Phone Number Must Be Of Minimum 10 Digits";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.contactNumber && String(self.contactNumber).match(/^[0-9]*$/) && self.contactNumber.length > 13) {
                    self.contactNumberError = "Phone Number Must Be Of Maximum 13 Digits";
                    if (checked) {
                        checked = false;
                    }
                }

                if (!self.roleId) {
                    self.scheduledForError = "Scheduled For Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.status) {
                    self.statusError = "Status Required";
                    if (checked) {
                        checked = false;
                    }
                }
                self.rectypeError = "";
                if (typ == 'recursive') {
                    if (!self.recursiveType) {
                        self.rectypeError = "Recursive Type Required";
                        if (checked) {
                            checked = false;
                        }
                    }
                }
                self.weekDaysError = '';
                if (typ == 'recursive') {
                    if (recuTyp == 'weekly') {
                        if (!self.weekDays) {
                            self.weekDaysError = "Day Of Week Required";
                            if (checked) {
                                checked = false;
                            }
                        }
                    }
                }
                if (!self.type) {
                    self.typeError = "Type Required";
                    if (checked) {
                        checked = false;
                    }
                }

                return checked;
            },

            validEmail: function (email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },

            loadRole(loading, search, vm) {
                search = (search === null || typeof (search) === "undefined" || search == '') ? '' : search;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var data = {
                    search: search
                };
                HTTP.post("getroles", data, config)
                        .then(function (response) {
                            self.roleArr = response.data.content;
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                            }
                        });
            },

            loadWellnessAdd(loading, search, vm) {
                search = (search === null || typeof (search) === "undefined" || search == '') ? '' : search;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var roleId = (self.roleId === null || self.roleId == '') ? 0 : self.roleId.value;
                var locationId = (self.locationId === null || self.locationId == '') ? 0 : self.locationId.value;
                var data = {
                    search: search,
                    /*role_id: roleId,
                     location_id: locationId,*/
                };
                HTTP.post("getwellnesses", data, config)
                        .then(function (response) {
                            self.wellnessId = '';
                            self.wellnessArr = response.data.content;
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },

            loadLocationsAdd(loading, search, vm) {
                search = (search === null || typeof (search) === "undefined" || search == '') ? '' : search;
                var data = {
                    search: search
                };
                HTTP.post("getlocation", data)
                        .then(function (response) {
                            self.locationArr = [];
                            self.locationArr = response.data.content;
                            /*$.each(response.data.content, function (i) {
                             if (response.data.content[i].value == 0) {
                             self.locationArr.push(response.data.content[i]);
                             }
                             });
                             $.each(response.data.content, function (i) {
                             if (response.data.content[i].value != 0) {
                             self.locationArr.push(response.data.content[i]);
                             }
                             });*/
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },

            loadUsers(loading, search, vm) {
                search = (search === null || typeof (search) === "undefined" || search == '') ? '' : search;
                var data = {
                    search: search
                };
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                HTTP.post("getusers", data, config)
                        .then(function (response) {
                            self.userArr = response.data.content;
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },

            loadEvent() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };

                var data = {
                    id: segments[3],
                };
                self.showLoader();
                HTTP.post("getevent/" + segments[3], data, config)
                        .then(function (response) {
//                        self.locationId = response.data.content[0].location_name;
                            self.optionsStart.maxDate = moment(response.data.content[0].end_date).add(1, 'days').format("MM/DD/YYYY hh:mmA");
                            self.optionsEnd.minDate = moment(response.data.content[0].start_date).subtract(1, 'days').format("MM/DD/YYYY hh:mmA");
                            self.roleId = {
                                value: response.data.content[0].scheduled_for,
                                text: response.data.content[0].role_name,
                            };

                            self.locationId = [];
                            for (var i = 0; i < response.data.content[0].location.length; i++) {
                                self.locationId.push({'text': response.data.content[0].location[i].name, 'value': response.data.content[0].location[i].id});
                            }

                            /*self.locationId = {
                             value: response.data.content[0].location_id,
                             text: response.data.content[0].location_name,
                             };*/
                            setTimeout(function () {

                                self.title = response.data.content[0].title;
                                self.description = response.data.content[0].description;
                                self.startDate = moment(response.data.content[0].start_date).format("MM/DD/YYYY hh:mmA");
                                self.endDate = moment(response.data.content[0].end_date).format("MM/DD/YYYY hh:mmA");

                                self.duration = response.data.content[0].duration;
                                self.userId = response.data.content[0].contact_person;
                                self.contactEmail = response.data.content[0].contact_email;
                                self.contactNumber = response.data.content[0].contact_number;

                                self.status = {value: 'active', text: 'Active'};
                                $.each(self.statusArr, function (i) {
                                    if (response.data.content[0].status == self.statusArr[i].value) {
                                        self.status = self.statusArr[i];
                                    }
                                });
                                self.type = {value: 'normal', text: 'Normal'};
                                $.each(self.typeArr, function (i) {
                                    if (response.data.content[0].type == self.typeArr[i].value) {
                                        self.type = self.typeArr[i];
                                    }
                                });
                                self.recursiveType = {value: 'monthly', text: 'Monthly'};
                                $.each(self.recursiveTypeArr, function (i) {
                                    if (response.data.content[0].recursive_type == self.recursiveTypeArr[i].value) {
                                        self.recursiveType = self.recursiveTypeArr[i];
                                    }
                                });
                                self.weekDays = {value: '1', text: 'Monday'};
                                $.each(self.weekDaysArr, function (i) {
                                    if (response.data.content[0].day_of_week == self.weekDaysArr[i].value) {
                                        self.weekDays = self.weekDaysArr[i];
                                    }
                                });
                                if (response.data.content[0].wellness_id != null) {
                                    self.wellnessId = {
                                        value: response.data.content[0].wellness_id,
                                        text: response.data.content[0].wellness_title,
                                    };
                                }
                            }, 200);
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });
            },

            addEvent(flag) {
                self.checkForm();
                if (self.checkForm()) {
                    var path = window.location.pathname;
                    var segments = path.split("/");
                    var status = document.getElementById("status");
                    var type = document.getElementById("type");
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                    };
                    var wellnessId = (self.wellnessId === null || self.wellnessId == '') ? '' : self.wellnessId.value;
                    var start_date = '';
                    var end_date = '';
                    var recursive_type = '';
                    var day_of_week = '';
                    if (self.type.value == 'normal') {
                        start_date = self.startDate;
                        end_date = self.endDate;
                        recursive_type = '';
                        day_of_week = '';
                    } else {
                        recursive_type = self.recursiveType.value;
                        if (recursive_type == 'monthly' || recursive_type == 'yearly') {
                            start_date = self.startDate;
                            end_date = (self.endDate === null || self.endDate.trim() == '') ? '' : self.endDate;
                            day_of_week = '';
                        } else {
                            start_date = '';
                            end_date = '';
                            day_of_week = self.weekDays.value;
                        }
                    }

                    var locationsId = '';
                    for (var i = 0; i < self.locationId.length; i++) {
                        locationsId += (self.locationId[i].value) + ',';
                    }
                    locationsId = locationsId.replace(/,\s*$/, "");
                    if (segments[2] == 'updateevent') {
                        if (segments[3]) {
                            var data = {
                                title: self.title,
                                description: self.description,
                                startDate: start_date,
                                endDate: end_date,
                                duration: self.duration,
                                locationId: locationsId,
                                contactPerson: self.userId,
                                contactEmail: self.contactEmail,
                                contactNumber: self.contactNumber,
                                scheduledFor: self.roleId.value,
                                status: self.status.value,
                                type: self.type.value,
                                wellnessId: wellnessId,
                                recursiveType: recursive_type,
                                weekDay: day_of_week,
                                id: segments[3],
                            };
                            $("#addBenifitBtn").val("Updating ...");
                            $("#addBenifitBtn").prop("disabled", true);
                            // $("#addAndContinueCaseBtn").prop('disabled',true);
                            $("#CancelBenifit").prop("disabled", true);
                        } else {
                            if (flag == "Save and Continue") {
                                $("#addAndContinueBenifitBtn").val("Saving ...");
                                $("#addAndContinueBenifitBtn").prop("disabled", true);
                                $("#addBenifitBtn").prop("disabled", true);
                                $("#CancelBenifit").prop("disabled", true);
                            } else {
                                $("#addBenifitBtn").val("Saving ...");
                                $("#addBenifitBtn").prop("disabled", true);
                                $("#addAndContinueBenifitBtn").prop("disabled", true);
                                $("#CancelBenifit").prop("disabled", true);
                            }
                        }
                    } else {
                        var data = {
                            title: self.title,
                            description: self.description,
                            startDate: start_date,
                            endDate: end_date,
                            duration: self.duration,
                            locationId: locationsId,
                            contactPerson: self.userId,
                            contactEmail: self.contactEmail,
                            contactNumber: self.contactNumber,
                            scheduledFor: self.roleId.value,
                            status: self.status.value,
                            type: self.type.value,
                            wellnessId: wellnessId,
                            recursiveType: recursive_type,
                            weekDay: day_of_week,
                        };
                        if (flag == "Save and Continue") {
                            $("#addAndContinueBenifitBtn").val("Saving ...");
                            $("#addAndContinueBenifitBtn").prop("disabled", true);
                            $("#addBenifitBtn").prop("disabled", true);
                            $("#CancelBenifit").prop("disabled", true);
                        } else {
                            $("#addBenifitBtn").val("Saving ...");
                            $("#addBenifitBtn").prop("disabled", true);
                            $("#addAndContinueBenifitBtn").prop("disabled", true);
                            $("#CancelBenifit").prop("disabled", true);
                        }
                    }
                    self.showLoader();
                    HTTP.post("addupdateevent", data, config)
                            .then(function (response) {
                                if (segments[2] == 'updateevent') {
                                    if (segments[3]) {
                                        //console.log(segments[3]);
                                        $("#addBenifitBtn").val("Update");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelBenifit").prop("disabled", false);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueBenifitBtn").val("Save and Continue");
                                            $("#addAndContinueBenifitBtn").prop("disabled", false);
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#CancelBenifit").prop("disabled", false);
                                        } else {
                                            $("#addBenifitBtn").val("Save");
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#addAndContinueBenifitBtn").prop("disabled", false);
                                            $("#CancelBenifit").prop("disabled", false);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueBenifitBtn").val("Save and Continue");
                                        $("#addAndContinueBenifitBtn").prop("disabled", false);
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#CancelBenifit").prop("disabled", false);
                                    } else {
                                        $("#addBenifitBtn").val("Save");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#addAndContinueBenifitBtn").prop("disabled", false);
                                        $("#CancelBenifit").prop("disabled", false);
                                    }
                                }

                                if (response.data.message == "success") {
                                    // self.$router.push('/task/list');
                                    $("#errorMsg").html(response.data.content);
                                    /*console.log("if");*/
                                    $(".alert-danger").removeClass("hide");
                                    $(".alert-danger").addClass("show");
                                    if (flag == "Save and Continue") {
//                                $("html, body").animate({scrollTop: "0px"}, 500);
                                        $(".alert-success").addClass("show");
                                        self.locationId = '';
                                        self.locationArr = [];
                                        self.title = '';
                                        self.description = '';
                                        self.startDate = '';
                                        self.endDate = '';
                                        self.duration = '';
                                        self.userId = '';
                                        self.userArr = [];
                                        self.contactEmail = '';
                                        self.contactNumber = '';
                                        self.roleId = '';
                                        self.status = {value: 'active', text: 'Active'};
                                        self.type = {value: 'normal', text: 'Normal'};
                                        self.recursiveType = {value: 'monthly', text: 'Monthly'};
                                        self.weekDays = {value: '1', text: 'Monday'};
                                        /*$("#status option[value='']").attr('selected', true);
                                         $("#type option[value='']").attr('selected', true);*/
                                        self.loadLocationsAdd();
                                        self.loadWellnessAdd();
                                        self.loadRole();
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        $(".back_button").prop("disabled", true);
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                            self.buttonBack();
                                        }, 3000);
                                    }
                                } else {
                                    $("#alertError").show();
                                    /*console.log('else');*/
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < response.data.content.length; i++) {
                                            err += response.data.content[i] + "<br>";
                                        }
                                        $("#errorMsg").html(err);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                    }
                                    setTimeout(function () {
                                        $(".alert-danger").removeClass("show");
                                        $(".alert-danger").addClass("hide");
                                    }, 5000);
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                if (segments[2] == 'updateevent') {
                                    if (segments[3]) {
                                        $("#addBenifitBtn").val("Update");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelBenifit").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueBenifitBtn").prop("disabled", false);
                                            $("#addAndContinueBenifitBtn").val("Save and Continue");
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#CancelBenifit").prop("disabled", false);
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
//                                            $(".alert-success").toggleClass("show");
                                            self.locationId = '';
                                            self.locationArr = [];
                                            self.title = '';
                                            self.description = '';
                                            self.startDate = '';
                                            self.endDate = '';
                                            self.duration = '';
                                            self.userId = '';
                                            self.userArr = [];
                                            self.contactEmail = '';
                                            self.contactNumber = '';
                                            self.roleId = '';
                                            self.status = {value: 'active', text: 'Active'};
                                            self.type = {value: 'normal', text: 'Normal'};
                                            self.recursiveType = {value: 'monthly', text: 'Monthly'};
                                            self.weekDays = {value: '1', text: 'Monday'};
                                            self.loadLocationsAdd();
                                            self.loadWellnessAdd();
                                            self.loadRole();
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        } else {
                                            $("#addBenifitBtn").val("Save");
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#addAndContinueBenifitBtn").prop("disabled", true);
                                            $("#CancelBenifit").prop("disabled", false);
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        }

                                        if (err.response.status == 0) {
                                            self.errorMsg = "Remote server can not be reachable";
                                        } else {
                                            //redirect to login page if user not authenticated
                                            if (err.response.status == 401) {
                                                //clear previous data
                                                localStorage.removeItem("user_obj");
                                                localStorage.removeItem("api_token");
                                                localStorage.removeItem("profile_image");
                                                //EventBus.$emit("logged-in", true, "", "");
                                                self.$router.push("/login");
                                            }
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueBenifitBtn").prop("disabled", false);
                                        $("#addAndContinueBenifitBtn").val("Save and Continue");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#CancelBenifit").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
//                                        $(".alert-success").toggleClass("show");
                                        self.locationId = '';
                                        self.locationArr = [];
                                        self.title = '';
                                        self.description = '';
                                        self.startDate = '';
                                        self.endDate = '';
                                        self.duration = '';
                                        self.userId = '';
                                        self.userArr = [];
                                        self.contactEmail = '';
                                        self.contactNumber = '';
                                        self.roleId = '';
                                        self.status = {value: 'active', text: 'Active'};
                                        self.type = {value: 'normal', text: 'Normal'};
                                        self.recursiveType = {value: 'monthly', text: 'Monthly'};
                                        self.weekDays = {value: '1', text: 'Monday'};
                                        self.loadLocationsAdd();
                                        self.loadWellnessAdd();
                                        self.loadRole();
                                        /*$("#status option[value='']").attr('selected', true);
                                         $("#type option[value='']").attr('selected', true);*/
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        $("#addBenifitBtn").val("Save");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#addAndContinueBenifitBtn").prop("disabled", true);
                                        $("#CancelBenifit").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }

                                    if (err.response.status == 0) {
                                        self.errorMsg = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            //EventBus.$emit("logged-in", true, "", "");
                                            self.$router.push("/login");
                                        }
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }
                                }
                                self.hideLoader();
                            });
                }

                //
            },
            changeDateFormat: function (dateTime) {
                var parts = dateTime.split(" ");
                var time = parts[1];
                var hours = Number(time.match(/^(\d+)/)[1]);
                var minutes = Number(time.match(/:(\d+)/)[1]);
                var AMPM = '';
                if (time.indexOf('PM') != -1) {
                    AMPM = 'PM';
                } else {
                    AMPM = 'AM';
                }
                if (AMPM == "PM" && hours < 12)
                    hours = hours + 12;
                if (AMPM == "AM" && hours == 12)
                    hours = hours - 12;
                var sHours = hours.toString();
                var sMinutes = minutes.toString();
                if (hours < 10)
                    sHours = "0" + sHours;
                if (minutes < 10)
                    sMinutes = "0" + sMinutes;
                return new Date(parts[0] + " " + sHours + ":" + sMinutes + ":00");
            },

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/backend/events/AddEvent.vue